import React from "react";

import { Container, Row, Col, Card } from "reactstrap";
// import CountUp from 'react-countup';

import "react-circular-progressbar/dist/styles.css";

function AboutPoints() {
  const size =
    document.body.clientWidth >= 1024 || document.documentElement.clientWidth >= 1024
      ? true
      : false;
  return (
    <>
      <div
        className="section py-5"
        style={{
          background: "transparent",
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col className="ml-auto mr-auto text-dark" md={12}>
              <h1
                className="text-center text-g mb-5"
                style={{
                  fontSize: size ? "3rem" : "2rem",
                }}
              >
                KEY TOPICS
              </h1>
            </Col>

            {content.map((c, i) => (
              <Col xs={11} lg={c.lg || 4} className="pr-0">
                <div className="container-fluid row justify-content-center col-lg-11 col-xs-12 pr-0">
                  <Card
                    className="rounded-0 incomplete-box"
                    style={{
                      background: "transparent",
                      // border: "5px #5ab030 solid",
                    }}
                  >
                    <div className="container-fluid row ml-1 py-2">
                      <Col xs={2} className="align-self-center">
                        <img
                          src={require(`assets/icons/${c.image}`)}
                          style={{
                            minWidth: "80px",
                            marginLeft: "-40px",
                          }}
                          width="100%"
                          alt="about"
                          // className="mx-auto"
                        />
                      </Col>
                      <Col xs={10} className="align-self-center">
                        <p
                          className="text-400 mt-2 text-white"
                          dangerouslySetInnerHTML={{ __html: c.title }}
                        />
                      </Col>
                    </div>
                  </Card>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
}

export default AboutPoints;

// Digital Twins for immersive experiences for people in building cities and ultra-luxury destinations
// Case studies on Digital Twin implementation for Construction for Saudi Arabia’s Giga projects– value of Digital Twins on each business line and understanding the ROI
// Panel discussions – Standards, Policies, Contracts & Procurement in the Digital Twin ecosystem

const content = [
  {
    title: `<span class="text-f text-bold">
    SMART CITIES + AI SYNERGY:
</span>
 Explore how AI- powered digital twins are driving real-time decision- making, predictive urban planning, and hyper-efficient infrastructure delivery across the Kingdom.`,
    image: "DTSA-25-ICONS-20.png",
    lg: 12,
  },
  {
    title: `<span class="text-f text-bold">
   FROM CONCEPT TO CONCRETE:
</span>
 Hear firsthand how construction and engineering giants are embedding digital twin ecosystems from the earliest design stages to on-site execution.`,
    image: "DTSA-25-ICONS-21.png",
    lg: 12,
  },
  {
    title: `<span class="text-f text-bold">
    BEYOND THE BUILD: 
</span>
 Discover how digital twins are shaping the post-handover lifecycle — from asset management to sustainable operations in Saudi’s new urban environments.`,
    image: "DTSA-25-ICONS-22.png",
    lg: 12,
  },
  {
    title: `<span class="text-f text-bold">
    KINGDOM-WIDE SHOWCASE:
</span>
 Exclusive case studies from across giga-projects, ministries, and developers – putting you face-to-face with the masterminds leading Saudi Arabia’s Vision 2030 transformation.`,
    image: "DTSA-25-ICONS-23.png",
    lg: 12,
  },
];
